import { gql } from '@apollo/client';

const createMultiReceipts = gql`
  mutation ($input: [ReceiptInput]!) {
    createMultiReceipts(input: $input)
  }
`;

export default createMultiReceipts;
